import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {PopupVisibility} from '../../../@models/core';
import {StatusListener} from '../../../status-listener';
import {DepositMode} from '../../../../shared-gen/Payment/Status/DepositMode';
import {AppService} from '../../../services/app.service';
import {AppStatus} from '../../../@models/app-status';

@Component({
	selector: 'kkb-tur-cointubes-panel',
	templateUrl: './tur-cointubes-panel.component.html',
	styleUrls: ['./tur-cointubes-panel.component.scss', '../../../pages/tur/tur.scss']
})
export class TurCoinTubesPanelComponent extends StatusListener implements OnInit, OnDestroy {

	@Input() showAsModal: boolean = false;

	visibility: PopupVisibility = '';
	coins: number[][] = [ // Filled in onStatusChanged
		// [10, 0],
		// [20, 0],
		// ...
	];

	private requestOpenTimer = 0;


	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		const payment = status.deviceStatus.PaymentStatus;
		// Coins deposit mode change? Then show/hide popup
		if (payment.CoinsDepositMode === 'Change' && this.visibility !== 'popupVisible')
			this.open();
		else if (payment.CoinsDepositMode !== 'Change' && this.visibility === 'popupVisible')
			this.close();
		// Coins in tubes changed? Then update values
		let coins: number[][] = [];
		if (payment.CoinsInTubes)
			coins = Object.entries(payment.CoinsInTubes).map(
				([key, value]) => [parseInt(key), value]);
		this.coins = coins;
	}

	open() {
		this.visibility = 'popupVisible';
	}

	close() {
		this.visibility = '';
	}

	startRequestOpen() {
		this.requestOpenTimer = window.setTimeout(() => {
			clearTimeout(this.requestOpenTimer);
			this.requestOpenTimer = 0;
			this.app.api.paymentApi.setCoinsDepositMode(DepositMode.Change);
		}, 3000);
	}

	cancelRequestOpen() {
		if (this.requestOpenTimer !== 0) {
			clearTimeout(this.requestOpenTimer);
			this.requestOpenTimer = 0;
		}
	}

	requestClose() {
		this.app.api.paymentApi.setCoinsDepositMode(DepositMode.Credit);
	}

	preventBubble(event: Event = null) {
		if (event) {
			event.stopPropagation();
		}
	}

}
